export const MENU_PATHS_MAP = [
    {name: "회사소개", path: "company"},
    {name: "제품정보", path: "products"},
    {name: "연구주제", path: "lab"},
    {name: "Career", path: "career"},
    {name: "웅분석", path: "analysis"},
]
export const COMPONENTS_MAP = [
    {name: "Detail", path: "detail"},
    {name: "Overview", path: "overview"},
    {name: "FourDepthTest", path: "four-depth-test"},
    {name: "FourDepthTwoTest", path: "four-depth-two-test"},
    {name: "Vision", path: "vision"},
    {name: "History", path: "history"},
    {name: "BusinessField", path: "business-field"},
    {name: "SocialContribution", path: "social-contribution"},
    {name: "LocationMap", path: "location-map"},
    {name: "Value", path: "value"},
    {name: "Culture", path: "culture"},
    {name: "Benefit", path: "benefit"},
    {name: "AnalysisServiceInfo", path: "analysis-service-info"},
    {name: "DetailInfo", path: "detail-info"},
]